const APP_STORE_URLS = {
  ios: 'https://apps.apple.com/us/app/mychoc/id6457740952',
  android: 'https://play.google.com/store/apps/details?id=com.choc.ufd.android'
}

const DEFAULT_FALLBACK_DELAY_MS = 3000

const getUA = () =>
  typeof navigator !== 'undefined' ? navigator.userAgent : ''

export const isMobileDevice = () => {
  if (typeof navigator === 'undefined') {
    return false
  }
  return /android|iphone|ipad|ipod/i.test(getUA())
}

export const isIOSDevice = () => /iphone|ipad|ipod/i.test(getUA())

export const buildMobileDeeplinkUrl = (route, params) => {
  const scheme = process.env.EH_DEEPLINK_URL_SCHEME || 'choc'
  const base = `${scheme}://${route}`
  if (!params || Object.keys(params).length === 0) {
    return base
  }
  const qs = new URLSearchParams(params).toString()
  return `${base}?${qs}`
}

export const openMobileApp = ({
  route,
  params,
  onFallback,
  fallbackDelayMs = DEFAULT_FALLBACK_DELAY_MS
} = {}) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return
  }
  if (!isMobileDevice()) {
    if (onFallback) {
      onFallback()
    }
    return
  }
  const url = buildMobileDeeplinkUrl(route, params)
  const storeUrl = isIOSDevice() ? APP_STORE_URLS.ios : APP_STORE_URLS.android

  window.location.href = url

  const onVisibilityChange = () => {
    if (document.hidden) {
      clearTimeout(timer)
    }
  }
  const onPageHide = () => {
    clearTimeout(timer)
  }

  document.addEventListener('visibilitychange', onVisibilityChange, {
    once: true
  })
  window.addEventListener('pagehide', onPageHide, { once: true })

  const timer = setTimeout(() => {
    if (!document.hidden && document.visibilityState === 'visible') {
      window.location.href = storeUrl
    }
  }, fallbackDelayMs)
}
